<template>
  <header
    v-if="!Edicao"
    class="sticky top-0 z-50 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 shadow-sm"
  >
    <div class="flex items-center justify-between px-6 py-4">
      <!-- Logo -->
      <CompanyLogo :nome-empresa="nomeEmpresa" :is-dark="isDark" />

      <!-- Navigation buttons -->
      <div class="hidden lg:flex items-center gap-3">
        <!-- Dark mode toggle -->
        <button
          @click="toggleTheme"
          class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
          aria-label="Toggle dark mode"
        >
          <svg
            v-if="!isDark"
            class="w-5 h-5 text-yellow-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
            />
          </svg>
          <svg
            v-else
            class="w-5 h-5 text-slate-300"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
            />
          </svg>
        </button>

        <!-- Alterar senha -->
        <button
          v-if="configuracaoToken != 'S'"
          @click="alterarSenha()"
          class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          Alterar senha
        </button>

        <!-- Logoff -->
        <button
          @click="logoff"
          class="px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
        >
          Logoff
        </button>
      </div>
    </div>
  </header>

  <!-- Overlay Mobile -->
  <Transition name="fade">
    <div
      v-if="menuAberto && !Edicao"
      @click="menuAberto = false"
      class="fixed inset-0 bg-black/50 dark:bg-black/70 z-40 lg:hidden"
    ></div>
  </Transition>

  <!-- Sidebar Mobile -->
  <Transition name="slide">
    <div
      v-if="menuAberto && !Edicao"
      class="fixed top-0 left-0 h-full w-80 bg-white dark:bg-slate-900 shadow-2xl z-50 overflow-y-auto lg:hidden"
    >
      <!-- Header -->
      <div
        class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-slate-700"
      >
        <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Cadastro Fundos de Investimento
        </h3>
        <button
          @click="menuAberto = false"
          class="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Menu items -->
      <nav class="p-4">
        <ul class="space-y-2">
          <li v-for="({ item, index }) in itensVisiveis" :key="index">
            <a
              href="javascript:;"
              @click="selectTab(index)"
              :class="[
                'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                tab === index
                  ? 'bg-primary text-white dark:bg-blue-600'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800',
                tab > index && 'text-green-600 dark:text-green-400',
              ]"
            >
              <!-- Checkmark se preenchido -->
              <svg
                v-if="tab > index"
                class="w-5 h-5 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                />
              </svg>
              <span>{{ item }}</span>
            </a>
          </li>

          <!-- Logout -->
          <li class="pt-4 border-t border-gray-200 dark:border-slate-700">
            <a
              href="javascript:;"
              @click="logoff"
              class="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              Sair
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </Transition>

  <!-- Mobile Toggle Button -->
  <div
    v-if="!Edicao"
    class="lg:hidden sticky top-0 z-30 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 px-4 py-3"
  >
    <div class="flex items-center justify-between">
      <button
        @click="menuAberto = !menuAberto"
        class="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ nomeMenu }}
      </span>

      <!-- Dark mode toggle mobile -->
      <button
        @click="toggleTheme"
        class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
      >
        <svg
          v-if="!isDark"
          class="w-5 h-5 text-yellow-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
          />
        </svg>
        <svg
          v-else
          class="w-5 h-5 text-slate-300"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
          />
        </svg>
      </button>
    </div>
  </div>
  <!-- Container Principal -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
    <!-- Título -->
    <div v-if="!Edicao" class="mb-6">
      <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        Cadastro
      </h2>
    </div>

    <!-- Navegação Wizard Desktop - Stepper Moderno -->
    <div v-if="!Edicao" class="hidden lg:block mb-8">
      <div class="relative">
        <div class="flex items-start justify-between">
          <div
            v-for="({ item, index }, visualIndex) in itensVisiveis"
            :key="index"
            class="flex flex-col items-center flex-1 relative"
            :class="{
              'cursor-pointer': index <= maxTab,
              'cursor-not-allowed': index > maxTab,
            }"
            @click="index <= maxTab && selectTab(index)"
          >
            <!-- Linha conectora -->
            <div
              v-if="visualIndex < itensVisiveis.length - 1"
              class="absolute top-5 left-1/2 w-full h-0.5 -z-10"
              :class="[
                index < tab
                  ? 'bg-green-500 dark:bg-green-400'
                  : 'bg-gray-200 dark:bg-slate-700',
              ]"
            ></div>

            <!-- Círculo com número/check -->
            <div
              class="flex items-center justify-center w-10 h-10 rounded-full border-2 mb-2 transition-all duration-200"
              :class="[
                tab === index
                  ? 'bg-primary border-primary text-white dark:bg-blue-600 dark:border-blue-600 scale-110 shadow-lg'
                  : index < tab
                  ? 'bg-green-500 border-green-500 text-white dark:bg-green-400 dark:border-green-400'
                  : index <= maxTab
                  ? 'bg-white border-gray-300 text-gray-700 dark:bg-slate-800 dark:border-slate-600 dark:text-gray-300 hover:border-primary dark:hover:border-blue-500'
                  : 'bg-gray-100 border-gray-200 text-gray-400 dark:bg-slate-900 dark:border-slate-800 dark:text-slate-600',
              ]"
            >
              <!-- Checkmark para etapas concluídas -->
              <svg
                v-if="index < tab"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <!-- Número para etapas atuais/futuras -->
              <span v-else class="text-sm font-semibold">{{ visualIndex + 1 }}</span>
            </div>

            <!-- Label -->
            <span
              class="text-xs text-center max-w-[120px] leading-tight transition-colors"
              :class="[
                tab === index
                  ? 'text-primary font-semibold dark:text-blue-400'
                  : index < tab
                  ? 'text-green-600 font-medium dark:text-green-400'
                  : index <= maxTab
                  ? 'text-gray-600 dark:text-gray-400'
                  : 'text-gray-400 dark:text-slate-600',
              ]"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Dinâmico -->
    <div
      class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 overflow-hidden"
    >
      <!-- Wrapper com padding controlado -->
      <div class="p-4 sm:p-6">
        <div v-if="tab == 0">
          <DadosEmpresa
            v-if="informacoesEmpresa"
            ref="form_0"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesEmpresa" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 1">
          <Procuradores
            v-if="informacoesEmpresa"
            ref="form_1"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesEmpresa" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 2">
          <Participantes
            v-if="
              informacoesParticipantesRepresentantes &&
              informacoesParticipantes &&
              emissoresDeOrdensBD
            "
            :informacoesParticipantes="informacoesParticipantes"
            ref="form_2"
            :Edicao="Edicao"
            :emissoresDeOrdensBD="emissoresDeOrdensBD"
          />
          <div
            v-if="!informacoesParticipantes || !emissoresDeOrdensBD"
            class="loading-overlay"
          >
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 3">
          <DadosFinanceiros
            v-if="informacoesFinanceiras"
            ref="form_3"
            :informacoesFinanceiras="informacoesFinanceiras"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesFinanceiras" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 4">
          <DadosBancarios
            v-if="informacoesBancarias"
            ref="form_4"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesBancarias" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 5">
          <UploadDocumentos :Edicao="Edicao" ref="form_5" />
        </div>
        <div v-if="tab == 6">
          <OutrasInformacoes
            v-if="informacoesDeclaracoes !== null"
            ref="form_6"
            :informacoesDeclaracoes="informacoesDeclaracoes || {}"
            :Edicao="Edicao"
          />
          <div v-if="informacoesDeclaracoes === null" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 7">
          <Fatca
            v-if="informacoesDeclaracoes !== null"
            ref="form_7"
            :informacoesDeclaracoes="informacoesDeclaracoes || {}"
            :Edicao="Edicao"
          />
          <div v-if="informacoesDeclaracoes === null" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 8">
          <Produtos :Edicao="Edicao" :nomeAbaProdutos="nomeAbaProdutos" ref="form_8" />
        </div>
      </div>

      <!-- Footer Fixo -->
      <div
        class="sticky bottom-0 lg:static bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700 px-4 sm:px-6 py-4"
      >
        <div class="flex flex-col sm:flex-row gap-3 sm:justify-between">
          <button
            @click="validarFormularioAtual"
            class="order-2 sm:order-1 px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
          >
            {{ Edicao ? "Salvar" : "Salvar e continuar depois" }}
          </button>

          <button
            v-if="!Edicao"
            @click="proximaEtapa"
            class="order-1 sm:order-2 px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm"
          >
            {{ tab == 8 ? "Concluir" : "Avançar" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ModalAlterarSenha />
</template>

<script>
import CompanyLogo from "@/components/CompanyLogo.vue";
import { mapGetters, mapActions } from "vuex";
import { useTheme } from "@/composables/useTheme";
import DadosEmpresa from "./DadosEmpresa.vue";
import Participantes from "./Participantes.vue";
import DadosFinanceiros from "./DadosFinanceiros.vue";
import DadosBancarios from "./DadosBancarios.vue";
import UploadDocumentos from "./UploadDocumentos.vue";
import OutrasInformacoes from "./OutrasInformacoes.vue";
import Fatca from "./Fatca.vue";
import Produtos from "./Produtos.vue";
import api from "@/api/axios";

import navigationTracker from "@/services/modules/userNavigationTracker";
import Procuradores from "./Procuradores.vue";
import ModalAlterarSenha from "../AlterarSenha/ModalAlterarSenha.vue";
export default {
  components: {
    CompanyLogo,
    DadosEmpresa,
    Participantes,
    DadosFinanceiros,
    DadosBancarios,
    UploadDocumentos,
    OutrasInformacoes,
    Produtos,
    Fatca,
    Procuradores,
    ModalAlterarSenha,
  },
  props: ["Edicao", "BloquearSalvarIsolado"],
  name: "CadastroFI_Passo_1",

  setup() {
    const { isDark, toggleTheme } = useTheme();
    return { isDark, toggleTheme };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      infoBasica: "GET_FI_INFO_EMPRESA",
      infoFinanceiro: "GET_FI_INFO_FINANCEIRO",
      infoBancario: "GET_FI_INFO_BANCARIO",
      infoDeclaracao: "GET_FI_INFO_DECLARACAO",
      infoParticipante: "GET_FI_INFO_PARTICIPANTE",
      infoParticipanteRepresentante: "GET_FI_INFO_PARTICIPANTE_REPRESENTANTE",
      emissoresDeOrdensBD: "GET_FI_INFO_EMISSOR_ORDEM",
      salvarInformacoesFI: "GET_FI_SALVAR_INFO",
      salvarObjInfoBasicas: "GET_FI_SALVAR_INFO_BASICAS",
      salvarObjInfoFinanceiro: "GET_FI_SALVAR_INFO_FINANCEIRO",
      salvarObjInfoBancario: "GET_FI_SALVAR_INFO_BANCARIO",
      salvarObjInfoBancarioAdicional: "GET_FI_SALVAR_INFO_BANCARIO_ADICIONAL",
      salvarObjInfoDeclaracao: "GET_FI_SALVAR_INFO_DECLARACAO",
      salvarObjinfoParticipante: "GET_FI_SALVAR_INFO_PARTICIPANTE",
      salvarDadosEmissorOrdemObj: "GET_FI_SALVAR_INFO_EMISSOR_ORDEM",
      ObjSalvarInformacoesUploadArquivos: "GET_SALVAR_INFO_UPLOAD",
      salvarObjInfoParticipanteRepresentante:
        "GET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE",
      etapaCadastro: "GET_ETAPA_CADASTRO",
      etapasConcluidas: "GET_ETAPA_CONCLUIDA",
      salvarObjConcluir: "GET_FICHA_CONCLUIR",
      desabilitarNotificacao: "GET_SALVAR_INFO_DES_NOTIFICACAO",
      getConfiguracoes: "GET_CONFIGURACOES",
      enviarCadastro: "GET_ENVIAR_CADASTRO",
    }),
    salvouTodasAbas() {
      const { gravarDados } = this;
      return Object.values(gravarDados).every((value) => value === 1);
    },
    nomeMenu() {
      const menus = [
        "Dados cadastrais",
        "Procuradores",
        "Participantes",
        "Dados Financeiros",
        "Dados Bancários",
        "Upload de Documentos",
        "Declarações",
        "FATCA",
        this.nomeAbaProdutos,
      ];
      return menus[this.tab] || "Menu Desconhecido";
    },
    menuItems() {
      return [
        "Dados cadastrais",
        "Procuradores",
        "Participantes",
        "Dados Financeiros",
        "Dados Bancários",
        "Upload de Documentos",
        "Declarações",
        "FATCA",
        this.nomeAbaProdutos,
      ];
    },
    itensVisiveis() {
      return this.menuItems
        .map((item, index) => ({ item, index }))
        .filter(({ index }) => !(this.nomeEmpresa === "GENIAL" && index === 4));
    },
  },
  data() {
    return {
      menuAberto: false,
      maxTab: 0,
      configuracaoToken: "n",
      nomeAbaProdutos: "Produtos",
      solicitouProximaEtapa: false,
      gravarDados: {
        salvarInformacoesFI: 0,
        salvarDadosFinanceiro: 0,
        salvarDadosBancario: 0,
        salvarDadosBancarioAdicional: 0,
        salvarDadosParticipante: 0,
        salvarDadosParticipanteRepresentante: 0,
        salvarDadosDeclaracao: 0,
        salvarInformacoesUpload: 0,
        salvarDadosEmissorOrdem: 0,
      },
      nomeEmpresa: "",
      tab: 0,
      informacoesEmpresa: null,
      informacoesBancarias: null,
      informacoesFinanceiras: null,
      informacoesDeclaracoes: null,
      informacoesParticipantes: null,
      informacoesParticipantesRepresentantes: null,
    };
  },
  created() {
    this.$store.commit("SET_MODAL_QUESTIONARIO", false);
    this.$store.dispatch("FETCH_QUESTIONARIO_BUSCAR_QUESTOES");
    this.$store.commit("SET_FICHA_CONCLUIR", false);
    this.$store.dispatch("FETCH_CONSULTA_DISCLAIMER");
    this.obterDados();
  },
  async mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.$store.commit("SET_FI_SALVAR_INFO", false);
    if (!this.Edicao) {
      this.$store.commit("SET_ETAPA_CADASTRO", 0);
    } else {
      this.tab = this.etapaCadastro;
    }

    await this.fetchConfiguracao([
      "Modo de autenticação",
      "Habilitar quantidade de caracteres nos campos nome",
      "OnBoarding - Nomeclatura da aba de produto",
    ]);
    this.configuracaoToken =
      this.getConfiguracoes("Modo de autenticação")?.Valor != "2" ? "N" : "S";

    this.nomeAbaProdutos =
      this.getConfiguracoes("OnBoarding - Nomeclatura da aba de produto")
        ?.Valor ?? "Produtos";

    if (this.infoBasica != null) this.informacoesEmpresa = this.infoBasica;

    if (this.infoParticipante != null)
      this.informacoesParticipantes = this.infoParticipante;

    if (this.infoFinanceiro != null)
      this.informacoesFinanceiras = this.infoFinanceiro;

    if (this.infoBancario != null)
      this.informacoesBancarias = this.infoBancario;

    if (this.infoParticipanteRepresentante != null)
      this.informacoesParticipantesRepresentantes =
        this.infoParticipanteRepresentante;

    if (this.infoDeclaracao != null)
      this.informacoesDeclaracoes = this.infoDeclaracao;
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    async validarFormularioAtual() {
      const refName = `form_${this.tab}`;
      const componente = this.$refs[refName];

      if (this.Edicao && componente?.validarFormulario && this.tab != 1) {
        if (await componente.validarFormulario(true)) {
          if (componente?.salvarInformacoes) {
            const sucesso = await componente.salvarInformacoes();
            if (sucesso !== false && refName === "form_5") {
              this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
              this.$emit("update:Edicao", false);
            }
          }
        }
      } else {
        if (componente?.salvarInformacoes) {
          componente.salvarInformacoes();
        } else {
          this.$swal({
            icon: "success",
            title: "Alterações realizadas com sucesso!",
            text: "Dados informados foram salvos com sucesso.",
          });
        }
      }
    },
    proximaEtapa() {
      const refName = `form_${this.tab}`;
      const componente = this.$refs[refName];

      if (componente?.proximaEtapa) {
        componente.proximaEtapa();
      }
    },
    async obterDados() {
      await this.$store.dispatch("FETCH_FI_INFO_EMPRESA");
      await this.$store.dispatch("FETCH_FI_INFO_FINANCEIRO");
      await this.$store.dispatch("FETCH_FI_INFO_BANCARIO");
      await this.$store.dispatch("FETCH_FI_INFO_DECLARACAO");
      await this.$store.dispatch("FETCH_FI_INFO_PARTICIPANTE");
      await this.$store.dispatch("FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE");
      await this.$store.dispatch("FETCH_FI_INFO_EMISSOR_ORDEM");
      await this.$store.dispatch("FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE");
      await this.$store.dispatch("FETCH_CONSULTA_BANCOS");
      await this.$store.dispatch("FETCH_CONSULTA_ATIVIDADES", "FU");
      await this.$store.dispatch("FETCH_CONSULTA_PAISES");
      await this.$store.dispatch("FETCH_CONSULTA_TIPO_FUNDO");
      await this.$store.dispatch("FETCH_FI_LISTA_PROCURADORES");
      await this.$store.commit("SET_SALVAR_INFO_UPLOAD", null);
      await this.$store.commit("SET_FI_SALVAR_INFO_BANCARIO", null);
      await this.$store.commit("SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL", null);
      await this.$store.dispatch("FETCH_CONSULTA_NATUREZA_JURIDICA");
    },
    selectTab(tabSelected) {
      if (tabSelected < this.tab || tabSelected <= this.maxTab) {
        this.tab = tabSelected;

        if (this.maxTab < this.tab) {
          this.maxTab = this.tab;
        }

        this.$store.commit("SET_ETAPA_CADASTRO", this.tab);
      }
      this.menuAberto = false;
    },
    alterarSenha() {
      this.$store.commit("SET_ABRIR_ALTERAR_SENHA", 1);
    },
    formatarValorFinanceiro(valorString) {
      if (valorString === null || valorString === undefined) {
        return 0;
      }

      if (typeof valorString !== "string") {
        valorString = String(valorString);
      }

      const valorNumerico = parseFloat(
        valorString
          .replace(/\s/g, "") // remove todos os espaços (inclusive \u00A0)
          .replace("R$", "")
          .replace(/\./g, "")
          .replace(",", "."),
      );

      return isNaN(valorNumerico) ? 0 : valorNumerico;
    },
    logoff() {
      this.$store.dispatch("auth/logout");
    },
    async salvarConcluir() {
      if (this.salvarObjConcluir == true) {
        this.$store.commit("SET_FI_SALVAR_INFO", false);
        this.$store.commit("SET_FICHA_CONCLUIR", false);

        const data = {
          RenovacaoCadastral: this.BloquearSalvarIsolado,
        };

        await api
          .post("/Fundo/ConcluirCadastro", data)
          .then(async (retorno) => {
            if (retorno.status == 200) {
              // Notificar conclusao via SignalR
              await navigationTracker.trackCadastroCompleted({
                renovacao: this.BloquearSalvarIsolado,
                completedSteps: this.etapasConcluidas || [],
              });

              if (this.user.StatusCadastro > 1) {
                this.$swal({
                  icon: "warning",
                  title: "Cadastro atualizado",
                  text: "As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.",
                });

                this.user.StatusCadastro = 4;
                this.$store.commit("auth/SET_USER", this.user);
              } else {
                this.$alert({
                  icon: "success",
                  title: "Cadastro enviado!",
                  text: "Seu cadastro está em análise. Você receberá um e-mail em breve.",
                }).then((result) => {
                  if (result.value) {
                    this.logoff();
                  }
                });
              }
            }
          })
          .catch((error) => {
            this.$store.commit("SET_FI_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos.",
              text: `${error.response.data.data[0]}`,
            });
          });
      } else {
        this.$store.commit("SET_FI_SALVAR_INFO", false);
        if (this.desabilitarNotificacao == true) {
          this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", false);
        } else {
          if (!this.Edicao) {
            this.$swal({
              icon: "success",
              title: "Alterações realizadas com sucesso!",
              text: "Dados informados foram salvos com sucesso.",
            });
          }
        }
        this.obterDados();
      }
    },
    async salvarInformacoesUpload() {
      if (!this.salvarInformacoesFI) {
        return;
      }

      if (this.ObjSalvarInformacoesUploadArquivos == null) {
        this.gravarDados.salvarInformacoesUpload = 1;
        return;
      } else {
        const data = {
          documentos: this.ObjSalvarInformacoesUploadArquivos,
        };
        await api
          .post("/cliente/documentos", data)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.dispatch(
                "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
              );
              this.gravarDados.salvarInformacoesUpload = 1;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$store.commit("SET_SALVAR_INFO_UPLOAD", null);
            }
          })
          .catch((error) => {
            this.gravarDados.salvarInformacoesUpload = 2;
            this.$store.commit("SET_FI_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Falha ao realizar upload de documentos",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarDadosFinanceiro() {
      if (this.salvarInformacoesFI) {
        if (this.salvarObjInfoFinanceiro == null) {
          this.gravarDados.salvarDadosFinanceiro = 1;
          return;
        } else {
          const dadosFormatados = { ...this.salvarObjInfoFinanceiro };
          dadosFormatados.FaturamentoMedioMensal = this.formatarValorFinanceiro(
            dadosFormatados.FaturamentoMedioMensal,
          );
          dadosFormatados.CapitalSocial = this.formatarValorFinanceiro(
            dadosFormatados.CapitalSocial,
          );
          dadosFormatados.Patrimonio = this.formatarValorFinanceiro(
            dadosFormatados.Patrimonio,
          );
          await api
            .post("/Fundo/dadosFinanceiros", dadosFormatados)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_FI_SALVAR_INFO_FINANCEIRO", null);
                this.gravarDados.salvarDadosFinanceiro = 1;
                return;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosFinanceiro = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Informações.",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarDadosBancarioAdicional() {
      if (this.salvarInformacoesFI) {
        if (this.salvarObjInfoBancarioAdicional == null) {
          this.gravarDados.salvarDadosBancarioAdicional = 1;
          return;
        } else {
          await api
            .post("/Fundo/dadosBancarios", this.salvarObjInfoBancarioAdicional)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.dispatch("FETCH_FI_INFO_BANCARIO");
                this.$store.commit(
                  "SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL",
                  null,
                );
                this.gravarDados.salvarDadosBancarioAdicional = 1;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosBancarioAdicional = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Informações.",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarDadosBancario() {
      if (this.salvarInformacoesFI) {
        if (this.salvarObjInfoBancario == null) {
          this.gravarDados.salvarDadosBancario = 1;
          return;
        } else {
          await api
            .post("/Fundo/dadosBancarios", this.salvarObjInfoBancario)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_FI_SALVAR_INFO_BANCARIO", null);
                this.gravarDados.salvarDadosBancario = 1;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosBancario = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Informações.",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarDadosParticipanteRepresentante() {
      if (this.salvarInformacoesFI) {
        if (this.salvarObjInfoParticipanteRepresentante == null) {
          this.gravarDados.salvarDadosParticipanteRepresentante = 1;
          return;
        } else {
          await api
            .post(
              "/Fundo/representante",
              this.salvarObjInfoParticipanteRepresentante,
            )
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.dispatch(
                  "FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE",
                );
                this.gravarDados.salvarDadosParticipanteRepresentante = 1;
                this.$store.commit(
                  "SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE",
                  null,
                );
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosParticipanteRepresentante = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title:
                  "Dados informados inválidos de representantes na aba Participantes",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarDadosEmissorOrdem() {
      if (this.salvarInformacoesFI) {
        if (this.salvarDadosEmissorOrdemObj == null) {
          this.gravarDados.salvarDadosEmissorOrdem = 1;
          return;
        } else {
          await api
            .post(
              "/Fundo/pessoaAutorizadaEmitirOrdem",
              this.salvarDadosEmissorOrdemObj,
            )
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.dispatch("FETCH_FI_INFO_EMISSOR_ORDEM");
                this.gravarDados.salvarDadosEmissorOrdem = 1;
                this.$store.commit("SET_FI_SALVAR_INFO_EMISSOR_ORDEM", null);
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosEmissorOrdem = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title:
                  "Dados informados inválidos de emissor de ordem na aba Participantes",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarDadosParticipante() {
      if (this.salvarInformacoesFI) {
        if (this.salvarObjinfoParticipante == null) {
          this.gravarDados.salvarDadosParticipante = 1;
          return;
        } else {
          await api
            .post("/Fundo/participante", this.salvarObjinfoParticipante)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.gravarDados.salvarDadosParticipante = 1;
                this.$store.commit("SET_FI_SALVAR_INFO_PARTICIPANTE", null);
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosParticipante = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Participante",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarDadosDeclaracao() {
      if (this.salvarInformacoesFI) {
        if (this.salvarObjInfoDeclaracao == null) {
          this.gravarDados.salvarDadosDeclaracao = 1;
          return;
        } else {
          await api
            .post("/Fundo/declaracoes", this.salvarObjInfoDeclaracao)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.gravarDados.salvarDadosDeclaracao = 1;
                this.$store.commit("SET_FI_SALVAR_INFO_DECLARACAO", null);
              }
            })
            .catch((error) => {
              this.gravarDados.salvarDadosDeclaracao = 2;
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Declarações",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    executaProximaEtapa() {
      this.tab = this.etapaCadastro;

      if (this.maxTab < this.tab) {
        this.maxTab = this.tab;
      }
    },
    async verificaSePassouPorTodosPassos() {
      this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
      var etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8];

      if (this.nomeEmpresa.toUpperCase() != "GENIAL") {
        etapasObrigatorias.push(4);
      }

      if (!Array.isArray(this.etapasConcluidas)) {
        return false;
      }

      const etapasConcluidas = Array.isArray(this.etapasConcluidas)
        ? this.etapasConcluidas.filter((e) => typeof e === "number")
        : [];

      const todasEtapasOk = etapasObrigatorias.every((etapa) =>
        etapasConcluidas.includes(etapa),
      );

      if (todasEtapasOk) {
        return true;
      } else {
        this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
        return false;
      }
    },
    async salvar() {
      this.salvarDadosFinanceiro();
      this.salvarDadosBancario();
      this.salvarDadosBancarioAdicional();
      this.salvarDadosParticipante();
      this.salvarDadosParticipanteRepresentante();
      this.salvarDadosDeclaracao();
      this.salvarInformacoesUpload();
      this.salvarDadosEmissorOrdem();
      if (this.salvarObjInfoBasicas == null) {
        this.gravarDados.salvarInformacoesFI = 1;
        this.$store.commit("SET_FI_SALVAR_INFO", false);
        return;
      } else {
        await api
          .post("/Fundo/informacaoBasica", this.salvarObjInfoBasicas)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_FI_SALVAR_INFO_BASICAS", null);
              this.$store.commit("SET_FI_SALVAR_INFO", false);
              this.gravarDados.salvarInformacoesFI = 1;
              return;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarInformacoesFI = 2;
            this.$store.commit("SET_FI_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
  },
  watch: {
    salvouTodasAbas(newVal) {
      if (newVal) {
        this.salvarConcluir();
        if (this.solicitouProximaEtapa) {
          this.executaProximaEtapa();
          this.$store.commit("SET_FI_SALVAR_INFO", false);
        } else if (this.enviarCadastro) {
          this.salvarConcluir();
        }
        this.gravarDados.salvarInformacoesFI = 0;
        this.gravarDados.salvarDadosFinanceiro = 0;
        this.gravarDados.salvarDadosBancario = 0;
        this.gravarDados.salvarDadosBancarioAdicional = 0;
        this.gravarDados.salvarDadosParticipante = 0;
        this.gravarDados.salvarDadosParticipanteRepresentante = 0;
        this.gravarDados.salvarDadosDeclaracao = 0;
        this.gravarDados.salvarInformacoesUpload = 0;
        this.gravarDados.salvarDadosEmissorOrdem = 0;
      }
    },
    etapaCadastro() {
      // this.$emit('update:informacoesBasicas', this.infoBasicas);
      if (this.Edicao) {
        this.tab = this.etapaCadastro;
      } else if (this.etapaCadastro == 0) {
        this.executaProximaEtapa();
      } else {
        this.solicitouProximaEtapa = true;
      }
    },
    enviarCadastro() {
      if (this.enviarCadastro) {
        this.$store.commit("SET_FI_SALVAR_INFO", true);
      }
    },
    infoParticipanteRepresentante() {
      this.informacoesParticipantesRepresentantes =
        this.infoParticipanteRepresentante;
    },
    infoParticipante() {
      this.informacoesParticipantes = this.infoParticipante;
    },
    infoBasica() {
      this.informacoesEmpresa = this.infoBasica;
    },
    infoFinanceiro() {
      this.informacoesFinanceiras = this.infoFinanceiro;
    },
    infoBancario() {
      this.informacoesBancarias = this.infoBancario;
    },
    infoDeclaracao() {
      this.informacoesDeclaracoes = this.infoDeclaracao;
    },
    async salvarInformacoesFI() {
      if (this.salvarInformacoesFI) {
        if (this.BloquearSalvarIsolado) {
          this.$store.commit("SET_MODAL_QUESTIONARIO", false);
          this.$emit("update:Edicao", false);

          if (
            (await this.verificaSePassouPorTodosPassos()) == false ||
            !this.enviarCadastro
          ) {
            this.$store.commit("SET_FI_SALVAR_INFO", false);
            this.$store.commit("SET_ENVIAR_CADASTRO", false);
            return;
          }
          this.$store.commit("SET_ENVIAR_CADASTRO", false);
          this.$store.commit("SET_FICHA_CONCLUIR", true);
        } else if (
          this.Edicao &&
          !this.BloquearSalvarIsolado &&
          !this.enviarCadastro
        ) {
          this.$store.commit("SET_FI_SALVAR_INFO", false);
          this.$store.commit("SET_ENVIAR_CADASTRO", false);
          this.$store.commit("SET_MODAL_AVISO", "ModalConfirmar");
          this.$emit("update:Edicao", false);
          this.$store.commit("SET_FICHA_CONCLUIR", true);
          return;
        }

        this.salvar();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

/* Estilos globais */
body,
html {
  height: 100%;
  margin: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.link__before {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid;
  max-width: 70px;
}

.site-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 2rem;
  /* Ajuste conforme necessário */
  background-color: #fff;
  /* Ou qualquer cor de fundo que você deseja */
}

.info__resumo {
  display: flex;
  width: 100%;
  padding-bottom: 9px;

  .navegacao {
    display: flex;
    flex-wrap: wrap;

    .link {
      font-size: 14px;
      text-align: center;
      margin-right: 30px;
      margin-top: 20px;
      color: #667085;
      text-decoration: none;
      font-family: "Inter", sans-serif;
      font-weight: 500;

      &.first {
        text-align: left;
      }

      &.preenchido {
        font-size: 12px;
        padding-left: 30px;
        font-weight: 500;
        position: relative;
        text-decoration: none;
        // box-shadow: 0 3px 0 #00064F;
        color: #12481f;
        background-image: url("@/assets/aprovado.png");
        /* Atualize com o caminho correto */
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 20px 20px;
      }

      &.active {
        font-weight: 500;
        position: relative;
        text-decoration: none;
        // box-shadow: 0 3px 0 #00064F;
        color: #00064f;

        &::after {
          content: "";
          /* Necessário para que o pseudo-elemento seja exibido */
          position: absolute;
          /* Posiciona o pseudo-elemento em relação ao link */
          left: 0;
          /* Alinha à esquerda do link */
          bottom: -9px;
          /* Distância do sublinhado em relação à base do texto */
          width: 100%;
          /* Largura do sublinhado igual à do elemento link */
          height: 1px;
          /* Espessura do sublinhado */
          background-color: #00064f;
          /* Cor do sublinhado */
        }
      }
    }
  }
}

.logo img {
  height: 32px;
  /* Ajuste conforme o tamanho desejado para o logo */
  width: 142px;
}

.navigation ul {
  list-style: none;
  display: flex;
  gap: 1rem;
  /* Espaço entre os itens de navegação */
}

.navigation li {
  padding: 0.5rem 1rem;
  /* Ajuste conforme necessário */
}

.navigation a {
  text-decoration: none;
  color: #000;
  /* Cor do texto */
}

.navigation a.router-link-active {
  color: #00235c;
  /* Cor quando o link está ativo */
}

/* Estilização específica para o botão de cadastro */
.navigation a.router-link-exact-active {
  background-color: #00235c;
  /* Cor de fundo para o botão de cadastro */
  color: #fff;
  border-radius: 5px;
  /* Raio da borda para fazer os cantos arredondados */
  padding: 0.5rem 1rem;
}

/* Estilos para o container do login */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  padding-top: 0px;
  border-radius: 10px;
  background-color: white;
  //   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 80%;
  margin-left: 10%;
}

.logomark {
  width: 54px;
  height: 43.2px;
}

.info__headers {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #eaecf0;
}

.header {
  width: 100%;
  justify-content: flex-start;
}

.header h2 {
  width: 360px;
  /* Largura do elemento */
  height: 38px;
  /* Altura do elemento */
  font-family: "Gabarito", sans-serif;
  /* Família da fonte, certifique-se de que 'Gabarito' esteja importada ou substitua pelo nome correto da fonte */
  font-weight: 600;
  /* Peso da fonte semibold */
  font-size: 30px;
  /* Tamanho da fonte */
  line-height: 38px;
  /* Altura da linha */
  text-align: left;
  /* Alinhamento do texto ao centro */
  color: #101828;
  margin-bottom: 0px;
}

.header p {
  font-family: "Inter", sans-serif;
  /* Família da fonte Inter */
  font-weight: 400;
  /* Peso normal da fonte */
  font-size: 16px;
  /* Tamanho da fonte */
  line-height: 24px;
  /* Altura da linha */
  text-align: center;
  /* Alinhamento do texto ao centro */
  color: #6e6e6e;
  /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.footer p {
  font-family: "Inter", sans-serif;
  color: #667085;
  /* Este é um cinza genérico, ajuste conforme necessário */
  font-size: 16px;
  /* Exemplo de tamanho de fonte, ajuste conforme necessário */
  line-height: 24px;
  /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
  font-weight: 600;
  /* Para 'Cadastre-se', que parece ser mais destacado */
  color: #101828;
  /* Este é o azul padrão de links, ajuste conforme necessário */
  text-decoration: none;
  /* Para sublinhar o link */
}

.entrar-button {
  color: #667085;
  background: white;
}

input {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px;
  margin-bottom: 16px;
  /* Ajuste para a linha de altura */
  border: 1px solid #ccc;
  border-radius: 8px;
  /* Arredondamento dos inputs */
  box-sizing: border-box;
  /* Garante que o padding não adicione largura extra */
  width: 100%;
  /* Para garantir que os inputs ocupem toda a largura do container */
}

.erroBorder {
  border: 1px solid #e73d3d !important;
  margin-bottom: 0px;
}

.erro {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  margin-top: 0px;
  color: #e73d3d;
}

/* Estilos para os rótulos (labels) do formulário */
.form .input-field label {
  font-family: "Inter", sans-serif;
  /* Família da fonte Inter */
  font-weight: 500;
  /* Peso médio da fonte */
  font-size: 14px;
  /* Tamanho da fonte */
  line-height: 20px;
}

/* Estilos para o formulário */
form {
  display: flex;
  flex-direction: column;
}

/* Media query para telas menores */
@media (max-width: 600px) {
  .login-container {
    margin: 20px;
    padding: 10px;
    input,
    button {
      margin-bottom: 10px;
    }
  }

  h2 {
    text-align: center;
    margin-bottom: 20px;
  }

  .forgot-password {
    font-family: "Inter", sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064f;
    text-decoration: none;
  }

  .signup {
    text-align: center;
    margin-top: 20px;
  }

  .signup a {
    color: blue;
    text-decoration: none;
  }
}
</style>
